<template>
  <div class="question-wrapper">
    <div class="question-title">如何在线培训？</div>
    <div class="item">
      <div class="title" style="padding-top: 0.3rem">
        <span class="computer"></span>
        使用pc端进行学习
      </div>
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child active">PC端</div>
            <div class="child">小程序端</div>
          </div>
          <div class="text">第一步：登录账号</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image1%402x.png"
            style="width: 8.2rem"
          />
        </div>
      </div>
    </div>
    <div class="item" style="padding-top: 0.36rem">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child active">PC端</div>
            <div class="child">小程序端</div>
          </div>
          <div class="text">第二步：点击“我的学习”中的“学习任务”</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image2%402x.png"
            style="width: 9.14rem"
          />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child active">PC端</div>
            <div class="child">小程序端</div>
          </div>
          <div class="text">第三步：点击“继续学习”，进行相关培训班的学习</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image3%402x.png"
            style="width: 8.16rem"
          />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child active">PC端</div>
            <div class="child">小程序端</div>
          </div>
          <div class="text">
            第四步：完成学习后进行考试，考试通过后可在
            “结业证明”中查看对应的证书
          </div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image4%402x.png"
            style="width: 8.56rem"
          />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title" style="padding-top: 0.7rem">
        <span class="mobile"></span>
        使用小程序端进行学习
      </div>
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child">PC端</div>
            <div class="child active">小程序端</div>
          </div>
          <div class="text">第一步：扫描官网的小程序二维码或搜索“工友钉”</div>
          <div class="xcx-code">
            <img
              src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/cover/wechat_app_code.png"
              style="width: 1.85rem"
            />
          </div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image5%402x.png"
            style="width: 5.3rem; margin-right: 0.88rem"
          />
        </div>
      </div>
    </div>
    <div class="item" style="padding-top: 0.7rem">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child">PC端</div>
            <div class="child active">小程序端</div>
          </div>
          <div class="text">第二步：登录账号，账号为pc端注册账号</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image6%402x.png"
            style="width: 6rem; margin-right: 0.32rem"
          />
        </div>
      </div>
    </div>
    <div class="item" style="padding-top: 0.7rem">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child">PC端</div>
            <div class="child active">小程序端</div>
          </div>
          <div class="text">第三步：点击“我的课程”培训班学习</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image7%402x.png"
            style="width: 7.13rem"
          />
        </div>
      </div>
    </div>
    <div class="item" style="padding-top: 0.7rem">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child">PC端</div>
            <div class="child active">小程序端</div>
          </div>
          <div class="text">第四步：学习完成后进行考试</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image8%402x.png"
            style="width: 5.3rem; margin-right: 1.2rem"
          />
        </div>
      </div>
    </div>
    <div class="item" style="padding-top: 0.7rem">
      <div class="content">
        <div class="left">
          <div class="btn">
            <div class="child">PC端</div>
            <div class="child active">小程序端</div>
          </div>
          <div class="text">第五步：考试通过后可在“我的证书”中查看结业证书</div>
        </div>
        <div class="right">
          <img
            src="https://shdctech.oss-cn-hangzhou.aliyuncs.com/training/help/image9%402x.png"
            style="width: 6rem"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.question-wrapper {
  margin: 1rem auto 0;
  .question-title {
    font-size: 0.3rem;
    font-weight: bold;
    text-align: center;
  }
  .artice-info {
    margin: 0.15rem 0 0.41rem;
    font-size: 0.16rem;
    text-align: center;
  }
  .item {
    padding: 0.22rem 0 0.85rem;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 0.26rem;
      color: #007eff;
      margin-bottom: 0.48rem;
      .computer {
        display: inline-block;
        width: 0.39rem;
        height: 0.37rem;
        background-image: url(../../assets/images/computer.png);
        background-size: 100% 100%;
        margin-right: 0.14rem;
      }
      .mobile {
        display: inline-block;
        width: 0.36rem;
        height: 0.64rem;
        background-image: url(../../assets/images/mobile.png);
        background-size: 100% 100%;
        margin-right: 0.14rem;
      }
    }
    .content {
      width: 13.1rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .btn {
          display: flex;
          margin-bottom: 0.58rem;
          font-size: 0;
          .child {
            flex: 0 0 1.76rem;
            width: 1.76rem;
            height: 0.47rem;
            border-radius: 0.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: normal;
            font-size: 0.22rem;
            font-weight: bold;
            background-color: #eef0fb;
            color: #666666;
            position: relative;
            z-index: 1;
            &.active {
              background-color: #007eff;
              color: #fff;
              z-index: 2;
            }
            &:last-of-type {
              margin-left: -0.2rem;
            }
          }
        }
        .text {
          font-size: 0.2rem;
          line-height: 0.36rem;
          color: #333;
          font-weight: bold;
        }
        .xcx-code {
          position: absolute;
          top: 1.75rem;
        }
      }
    }
    &:nth-child(odd) {
      background: #f8fbff;
    }

    &:nth-child(even) {
      background: #fff;
    }
  }
}
</style>
